export const getIsPosting = state => state.getIn(['folder', 'isPosting']);
export const getIsFetching = state => state.getIn(['folder', 'isFetching']);
export const getIsPutting = state => state.getIn(['folder', 'isPutting']);
export const getErrMsg = state => state.getIn(['folder', 'errMsg']);

export const getFolderList = state => state.getIn(['folder', 'folderList']);